// extracted by mini-css-extract-plugin
module.exports = {"actionWrapper":"NewDeviceModal_actionWrapper__2PimR","backButtonContainer":"NewDeviceModal_backButtonContainer__2-D3V","backButtonText":"NewDeviceModal_backButtonText__1_fbp"};